<template>
  <EditDialog
    v-if="imgVisible"
    v-model:visible="imgVisible"
    :title="$t('components.ImgSelect.ada6c211c0589d1b889d6ab37e70bd16')"
    :hide-footer="false"
    :width="633"
    :z-index="1001"
    @submit="handleAvatar"
    @cancel="handleClose"
  >
    <div class="icon-select-wrap">
      <div class="preview">
        <p class="title">
          {{ $t('components.ImgSelect.bc8b97f44569fcddf978b68013643fc6') }}
        </p>
        <div class="img-bg fc">
          <img class="content img" :src="curAvatar" />
        </div>
      </div>
      <div class="icons">
        <p class="title" style="margin-left: 36px">
          {{ $t('components.ImgSelect.74191147f12563fee7236d41d0f61126') }}
        </p>
        <div class="img-content">
          <div
            v-for="i in imgList"
            :key="i"
            class="img-item-wrap fc"
            :class="{ active: curAvatar === i }"
            @click="handleClick(i)"
          >
            <img class="img" :src="i" />
          </div>
        </div>
      </div>
    </div>
  </EditDialog>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    curSrc: {
      type: String,
      default: ''
    },
    imgList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['select', 'close', 'update:visible'],
  setup(props, { emit }) {
    const curAvatar = ref(props.curSrc);
    const imgVisible = ref(props.visible);
    const handleClick = i => {
      curAvatar.value = i;
    };

    const handleAvatar = () => {
      imgVisible.value = false;
      emit('select', curAvatar.value);
    };
    const handleClose = () => {
      imgVisible.value = false;
      emit('close');
      emit('update:visible', false);
    };
    const show = () => {
      imgVisible.value = true;
      curAvatar.value = props.curSrc;
    };
    watch(
      () => props.visible,
      val => {
        if (val) {
          curAvatar.value = props.curSrc || props.imgList[0];
        }
        imgVisible.value = val;
      },
      {
        immediate: true
      }
    );
    return {
      imgVisible,
      curAvatar,
      handleClick,
      handleAvatar,
      handleClose,
      show
    };
  }
});
</script>

<style scoped lang="less">
.icon-select-wrap {
  width: 697px;
  display: flex;
  .title {
    color: var(--font-color);
    line-height: 20px;
    margin-bottom: 24px;
  }
  .preview {
    width: 121px;
    margin: 0 36px 0 20px;
    .img-bg {
      width: 102px;
      height: 102px;
      border-radius: 50%;
    }
  }
}
.img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.img-content {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, 1fr);
  border-left: 1px solid var(--border-neutral-color-secondary);
  padding-left: 34px;
  .img-item-wrap {
    width: 62px;
    height: 62px;
    padding: 3px;
    cursor: pointer;
    border-radius: 50%;
    &.active {
      border: 1px solid var(--theme-color);
    }
    img {
      border-radius: 50%;
      object-fit: cover;
    }
  }
}
</style>
